import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Component, ComponentRef, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ExternalUser } from '../../../domain/model/account/externalUser';
import { NotificationType } from '../../../domain/model/enums/notificationType';
import { PropertyDetailDto } from '../../../domain/model/properties/propertyDetailDto';
import { PropertyService } from '../../../domain/service/propertyService';
import { Icons } from '../../../enums/icons-enums';
import { AuthenticationService } from '../../../security/auth/authentication.service';
import { NotificationComponent } from '../../../shared/notification/notification.component';
import { DeactivatePropertyComponent } from '../deactivate-property/deactivate-property.component';
import { PropertiesDetailInfoComponent } from '../properties-detail-info/properties-detail-info.component';
import { PropertiesDetailOwnersComponent } from '../properties-detail-owners/properties-detail-owners.component';
import { PropertiesDetailReportingComponent } from '../properties-detail-reporting/properties-detail-reporting.component';
import { PropertiesSingleOwnerComponent } from '../properties-single-owner/properties-single-owner.component';
import { PropertiesDetailLicenseComponent } from '../properties-detail-license/properties-detail-license.component';
import { NativeIoService } from '../../../core/native/native-io.service';

@Component({
  selector: "app-properties-detail",
  templateUrl: "./properties-detail.component.html",
  styleUrl: "./properties-detail.component.css",
})
export class PropertiesDetailComponent implements OnInit {
  @ViewChild("propertiesDetailInfoComponent") propertiesDetailInfoComponent: PropertiesDetailInfoComponent | undefined;
  @ViewChild("propertiesDetailOwnersComponent") propertiesDetailOwnersComponent:
    | PropertiesDetailOwnersComponent
    | undefined;
  @ViewChild("propertiesSingleOwnerComponent") propertiesSingleOwnerComponent:
    | PropertiesSingleOwnerComponent
    | undefined;
  @ViewChild("propertiesDetailReportingComponent") propertiesDetailReportingComponent:
    | PropertiesDetailReportingComponent
    | undefined;

    @ViewChild("propertiesDetailLicense") propertiesDetailLicense:
    | PropertiesDetailLicenseComponent
    | undefined;
    
  model!: PropertyDetailDto;
  externalUser!: ExternalUser | null;
  private overlayRef!: OverlayRef;
  hasChanges = false;
  public icons = Icons;
  constructor(
    private readonly router: Router,
    private overlay: Overlay,
    public dialogRef: MatDialog,
    private readonly auth: AuthenticationService,
    private readonly propertyService: PropertyService,
    private readonly route: ActivatedRoute,
    private readonly nativeIo: NativeIoService
  ) {
    this.externalUser = this.auth.getCurrentUser2();
    const id: string = this.route.snapshot.params["id"];

    this.propertyService.getProperty(id).subscribe((data) => {
      if (data) this.model = data;
    });
  }
  showNotification(message: string, title: string, notificationType: NotificationType): void {
    // Create a Portal instance of our `NotificationComponent`
    const notificationPortal = new ComponentPortal(NotificationComponent);
    // Attach our `NotificationComponent` to the Overlay Portal
    const notificationRef: ComponentRef<NotificationComponent> = this.overlayRef.attach(notificationPortal);
    // Now we can access the component instance
    // and we can pass input for the `message` prop we created.
    notificationRef.instance.message = message;
    notificationRef.instance.title = title;
    notificationRef.instance.type = notificationType;
    notificationRef.instance.overlayRef = this.overlayRef;
    notificationRef.instance.getColor();

    // Set a timeout to detach our component from the overlay
    // after 3000 milliseconds
    setTimeout(() => {
      this.overlayRef.detach();
    }, 10000);
  }
  ngOnInit(): void {
    this.overlayRef = this.overlay.create({
      hasBackdrop: false,
      positionStrategy: this.overlay.position().global().top("20px").right("30px"),
    });
    this.propertiesDetailInfoComponent?.setFormData(this.model.rentalPropertyInfo);
  }
  openDeactivateModal(): void {
    const dialogRef = this.dialogRef.open(DeactivatePropertyComponent, {
      width: "479px",
      data: { id: this.model.rentalPropertyInfo.id },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The dialog was closed");
    });
  }
  onTabChange(index: number): void {
    console.log("Selected Tab Index:", index);
  }

  save(): void {
    this.propertiesDetailInfoComponent?.hasErrors();
    if (this.propertiesDetailInfoComponent?.rentalProperty.invalid) {
      this.propertiesDetailInfoComponent?.rentalProperty.markAllAsTouched();

      this.showNotification(
        "Rental Property contains empty fields that are required",
        "Important",
        NotificationType.Error
      );
      return;
    }

    this.propertiesDetailInfoComponent?.save();
    this.propertiesDetailReportingComponent?.save();
    this.propertiesDetailLicense?.save();
    if (this.externalUser?.accountType == 1) {
      this.propertiesDetailOwnersComponent?.save();
    } else {
      this.propertiesSingleOwnerComponent?.save();
    }

    this.showNotification("All changes were saved successfully", "Important", NotificationType.Info);
  }

  goToProperties() {
    this.router.navigate(["app/properties"]);
  }

  printReport() {
    this.nativeIo.openInternalRoute(['/reports/CertificateOfRegistration', this.model.rentalPropertyInfo.id]);

  }
  formHasChanges(value: boolean): void {
    this.hasChanges = value;
  }
}
